import camelCase from 'lodash/camelCase'
import React, { useState } from 'react'

import { Button, Icon, PriceString } from '@fourthwall/components'
import { TickIcon } from '@fourthwall/icons'

import type { IncentiveProps } from './Incentive.types'
import * as S from './styled'

export const Incentive = ({ type, icon, label, bonus, button, isCompleted }: IncentiveProps) => {
  const [isHovered, setIsHovered] = useState(false)

  const formattedId = camelCase(type)

  return (
    <S.Container
      id={formattedId}
      completed={isCompleted}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <S.Icon>{icon}</S.Icon>
      <S.Title>{label}</S.Title>
      {!isCompleted && bonus && (
        <S.Award>
          +<PriceString value={bonus.value} currency={bonus.currency} />
        </S.Award>
      )}
      {isCompleted && bonus && (
        <S.ButtonContainer>
          <S.Completed>
            <Icon component={TickIcon} height={14} width={14} />
            Earned <PriceString value={bonus.value} currency={bonus.currency} />
          </S.Completed>
        </S.ButtonContainer>
      )}

      {!isCompleted && button && (
        <S.ButtonContainer>
          <Button
            {...button}
            label={button.label}
            appearance={isHovered && !isCompleted ? 'primary' : 'secondary'}
            size="xsmall"
            data-analytics={formattedId}
          />
        </S.ButtonContainer>
      )}
    </S.Container>
  )
}
